const {throttle} = require('@exadel/esl/modules/esl-utils/async');

const {AmpersandView} = require('catalog/libs');

const HPEServices = require('../../base/hpe.services');
const HPEConstants = require('../../base/hpe.constants');
const ctaTemplate = require('./hpe.product.compare.page.template.tpl');

var ProductComparePageView = AmpersandView.extend({
	initialize() {
		HPEServices.subscribe(HPEConstants.catalog.COMPARE_LIST_CHANGE, this, function(compareList) {
			this.model.originPath = compareList.originPath;
		});

		this.render();
	},

	render() {
		var that = this;

		//make initial service call for analytics json
		this.model.fetch(window.location.href);

		// cache elements
		this.header = this.query('.intro');
		this.headerWrapper = this.query('.intro-wrapper');
		this.features = this.query('.features');
		this.featuresScrollContainer = this.query('.features .scroll-container');
		this.compareEl = this.query('.compare-wrapper');
		this.compareHeaderEl = this.query('.compare-block.overview');
		this.leftNav = this.query('.navigation-icon.left');
		this.rightNav = this.query('.navigation-icon.right');

		$(window).on('load', function() {
			that.headerHeight = that.header.offsetHeight;
			that.offsetTop = that.features.offsetTop;
			that.stickyHeader();
		});

		this.registerListeners();
	},

	events: {
		'click .delete': 'deleteItem',
		'click .navigation-icon.left:not(.disabled)': 'scrollContainerLeft',
		'click .navigation-icon.right:not(.disabled)': 'scrollContainerRight'
	},

	bindings: {
		'model.originPath': [
			{
				type: 'attribute',
				name: 'href',
				selector: '.return-link'
			},
			{
				type: function (el, value) {
					if (value) {
						el.style.display = 'block';
					}
				},
				selector: '.return-link'
			},
			{
				type: 'attribute',
				name: 'href',
				selector: '.cta a'
			},
			{
				type: function(el, value) {
					if (value) {
						el.style.display = 'block';
					}
				},
				selector: '.cta'
			}
		],
		'model.i18nAddAnother': {
			type: 'text',
			selector: '.cta a'
		}
	},

	registerListeners() {
		window.addEventListener('scroll', throttle(this.stickyHeader, 30, this));

		this.compareEl.addEventListener('scroll', throttle(this.repositionFixedHeader, 10, this));
		this.compareEl.addEventListener('scroll', throttle(this.repositionNavArrows, 10, this));
		this.headerWrapper.addEventListener('scroll', throttle(this.repositionFeatures, 10, this));

		window.addEventListener('resize', function() {
			this.resizeHeaderPostion();
			this.stickyHeader();
		}.bind(this));
	},

	deleteItem(event) {
		event.preventDefault();

		var that = this;

		var productId = event.target.parentNode.getAttribute('data-product-id');
		var elements = document.querySelectorAll('.compare-block.overview .row > div.product');

		//Add splice method to the array. querySelectorAll does not invoke array prototype.
		elements = Array.prototype.slice.call(elements, 0);

		function deletePosition(elements) {
			var idIndex, newDiv, newCTA; //eslint-disable-line no-unused-vars
			//Find array index match based off of the product ID attribute
			elements.forEach(function(el, index) {
				if (el.getAttribute('data-product-id') === productId) {
					idIndex = index;
				}
			});

			//Loop through each compare block. Empty and move each column.
			var blockRows = document.querySelectorAll('.compare-block .row');
			blockRows = Array.prototype.slice.call(blockRows, 0);
			blockRows.forEach(function(el) {
				if (elements.length > 1) {
					newDiv = document.createElement('div');
					newDiv.classList.add('no-product');
					if (el.children[idIndex].parentNode) {
						el.children[idIndex].parentNode.removeChild(el.children[idIndex]);
					}
					el.appendChild(newDiv);
				}
			});

			//add cta template to the new div element if it doesn't already exist on page
			if (elements.length === 4) {
				newDiv = document.querySelector('.compare-block.overview .no-product');
				newDiv.innerHTML = ctaTemplate;
				newCTA = document.querySelector('.compare-block.overview .no-product .cta a');

				//remove and reattach view bindings
				that._downsertBindings();
				that._upsertBindings();
			}

			//remove element from element list and update url
			if (elements.length > 1) {
				elements.splice(idIndex, 1);
				updateURL(elements);
			}

			//hide delete icon if last product
			if (elements.length === 1) {
				elements[0].querySelector('.delete').style.display = 'none';
			}

			//broadcast OID removal for compare tray persistance
			HPEServices.publish(HPEConstants.catalog.COMPARE_LIST_REMOVE, productId);
		}

		function updateURL(elements) {
			var urlList = ['compare'];
			var id;
			elements.forEach(function(el) {
				id = el.getAttribute('data-product-id');
				urlList.push('oid-' + id);
			});
			var url = urlList.join('.');
			window.history.replaceState({}, '', (url + '.html'));

			//make service call for analytics json
			that.model.fetch(window.location.href);
		}

		deletePosition(elements);
	},

	/**
	 * simple linear animation for nav arrow triggered scroll
	 */
	animateFrame(to, from) {
		var points = {
			'to': to,
			'from': from
		};
		var i;
		var frameCount = 12;
		var currentFrame = 0;
		var frames = [];
		var tweenAmount = (points.to - points.from) / frameCount;
		for (i = 0; i < frameCount; i++) {
		frames[i] = points.from + (tweenAmount * i);
		}

		frames.push(points.to);
		frameCount ++;

		var that = this;

		function step() {
			if (currentFrame < frameCount) {
				that.compareEl.scrollLeft = frames[currentFrame];
				that.repositionNavArrows();
				currentFrame ++;
				window.requestAnimationFrame(step);
			} else {
				that.model.animating = false;
			}
		}

		window.requestAnimationFrame(step);
	},

	scrollContainerLeft(event) {
		event.preventDefault();
		this.model.animating = true;
		this.animateFrame(0, this.compareEl.scrollLeft);
	},

	scrollContainerRight(event) {
		event.preventDefault();
		this.model.animating = true;
		var windowWidth = window.innerWidth;
		var containerWidth = this.featuresScrollContainer.offsetWidth;

		this.animateFrame((containerWidth - windowWidth), this.compareEl.scrollLeft);
	},
	/**
	 * Sticky header
	 */
	stickyHeader() {
		var that = this;
		var scrollTop = window.scrollY;

		if (scrollTop >= this.offsetTop) {
			that.features.style.paddingTop = that.headerHeight + 'px';
			that.header.classList.add('fixed');
			that.header.classList.add('animate');
			that.header.style.height = that.compareHeaderEl.offsetHeight + 'px';

			if (!that.model.headerEnabled) {
				that.repositionFixedHeader();
			}

			that.model.headerEnabled = true;
		} else {
			if (that.compareHidingCheck) {
				that.compareHidingCheck = false;
			}

			that.model.headerEnabled = false;
			that.header.classList.remove('fixed');
			that.header.classList.remove('animate');

			//Reset element positions
			that.features.style.paddingTop = 0 + 'px';
			that.header.style.height = 'auto';
		}

		this.repositionNavArrows();
	},

	/**
	 * recalculate fixed header position if window is resized.
	 */
	resizeHeaderPostion() {
		var that = this;

		if (this.header.classList.contains('fixed')) {
			/**
			 * Momentarily remove fixed class to calculate full element height.
			 * Used to set top padding of features section to allow for smooth transition
			 */
			that.header.classList.remove('fixed');
			that.features.style.paddingTop = '0px';
			that.headerHeight = that.header.offsetHeight;
			that.offsetTop = that.features.offsetTop;

			//Determine if header should still be fixed based off of new scroll position
			if (window.scrollY >= this.offsetTop) {
				that.header.classList.add('fixed');
				that.features.style.paddingTop = that.headerHeight + 'px';

				//recalculate header height and width for hiding scrollbar
				that.header.style.height = that.compareHeaderEl.offsetHeight + 'px';
			}
		} else {
			that.headerHeight = that.header.offsetHeight;
			that.offsetTop = that.features.offsetTop;
		}
	},

	/**
	 * scroll fixed header with main container body if header is fixed
	 * the second check is to prevent triggering the scroll event on the header
	 */
	repositionFixedHeader() {
		var that = this;
		if (this.header.classList.contains('fixed')) {
			if (that.model.scrollLeft !== that.compareEl.scrollLeft) {
				that.model.scrollLeft = that.compareEl.scrollLeft;
				that.headerWrapper.scrollLeft = that.model.scrollLeft;
			}
		}
	},

	/**
	 * scroll main body if fixed header is scrolled
	 * the second check is to prevent triggering the scroll event on the body
	 */
	repositionFeatures() {
		var that = this;
		if (this.header.classList.contains('fixed') && !this.model.animating) {
			if (that.model.scrollLeft !== that.headerWrapper.scrollLeft) {
				that.model.scrollLeft = that.headerWrapper.scrollLeft;
				that.compareEl.scrollLeft = that.model.scrollLeft;
			}
		}
	},

	/**
	 * reposition nav arrows when container is scrolled
	 */
	repositionNavArrows() {
		var windowWidth = window.innerWidth;
		var containerWidth = this.featuresScrollContainer.offsetWidth;

		var leftOffset = this.compareEl.scrollLeft;
		var rightOffset = this.compareEl.scrollLeft;

		if (!this.header.classList.contains('fixed')) {
			this.leftNav.style.transform = 'translate3d(' + leftOffset + 'px, -50%, 0)';
			this.rightNav.style.transform = 'translate3d(' + rightOffset + 'px, -50%, 0)';
		} else {
			this.leftNav.style.transform = 'translate3d(0px, -50%, 0)';
			this.rightNav.style.transform = 'translate3d(0px, -50%, 0)';
		}

		// Disable left arrow if scrolled all the way left
		if (this.compareEl.scrollLeft > 0) {
			this.leftNav.classList.remove('disabled');
		} else {
			this.leftNav.classList.add('disabled');
		}

		// Disable right arrow if scrolled all the way right
		if (containerWidth <= (windowWidth + this.compareEl.scrollLeft)) {
			this.rightNav.classList.add('disabled');
		} else {
			this.rightNav.classList.remove('disabled');
		}
	}
});

module.exports = ProductComparePageView;
